import { EVENT_DEFINITIONS } from './woopraEventDefinitions';

export const buildPathRegex = pattern => {
  // Escape regex-special characters except for our {…} placeholders
  const escaped = pattern.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  // Replace escaped placeholders \{…\} with a wildcard segment
  const withWildcards = escaped.replace(/\\\{[^}]+\\\}/g, '[^/]+');
  return new RegExp(`^${withWildcards}$`);
};

export const findMatchingEvents = (pathname, interactionType) =>
  compiledDefinitions.filter(def => def.type === interactionType && def.pathRegex.test(pathname));

const compiledDefinitions = EVENT_DEFINITIONS.map(def => ({
  ...def,
  pathRegex: buildPathRegex(def.path),
}));

export const closestTag = (startEl, tagName, stopEl = document) => {
  let el = startEl;
  const upperTag = tagName.toUpperCase();
  while (el && el !== stopEl) {
    if (el.tagName === upperTag) return el;
    el = el.parentElement;
  }
  return null;
};

export const getElementText = el => {
  if (!el) return '';
  const text = (el.textContent || '').trim();
  return text.length > 100 ? text.substring(0, 100) + '…' : text;
};
